import { getImgUrl,$io } from './index'

const components = {
    getImgUrl,
    $io
}

export default {
    install(Vue, options) {
        Object.keys(components).forEach(key => {
            Vue.prototype[`${key}`] = components[key]
        })
    }
}